import { Store, useStore } from 'vuex'
import { Commit, Dispatch, Getters } from './types'
import { RootState } from './index'

export interface UseStoreHooks {
  state: RootState
  commit: Commit
  dispatch: Dispatch
  getters: Getters
}

const getDestructureStore = (store: Store<RootState>): UseStoreHooks => {
  const { commit, dispatch, getters }: UseStoreHooks = store
  return {
    state: store.state,
    commit,
    dispatch,
    getters
  }
}

const useStoreHooks = (): UseStoreHooks => {
  const store = useStore()
  return getDestructureStore(store)
}

export { useStoreHooks, getDestructureStore }
export default useStoreHooks
